import { invariant } from "@epic-web/invariant";
import { polarClient } from "@polar-sh/better-auth";
import {
  adminClient,
  organizationClient,
  usernameClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { toast } from "sonner";

const { VITE_BETTER_AUTH_URL } = import.meta.env;

invariant(VITE_BETTER_AUTH_URL, "VITE_BETTER_AUTH_URL is not defined");

export const authClient = createAuthClient({
  baseURL: VITE_BETTER_AUTH_URL,
  basePath: "/api/auth",
  plugins: [
    adminClient(),
    usernameClient(),
    organizationClient(),
    polarClient(),
  ],
  fetchOptions: {
    credentials: "include",
    onError: async (context) => {
      const { response } = context;

      if (response.status === 429) {
        const message = "Rate limit exceeded. Please try again later.";

        console.error(message);
        toast.error(message);
      }
    },
  },
});

export type AuthSession = typeof authClient.$Infer.Session;
